export function Platform() {
  //Mozilla/5.0 (Linux; Android 5.0; SM-G900P Build/LRX21T) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3987.149 Mobile Safari/537.36
  //Mozilla/5.0 (iPhone; CPU iPhone OS 13_2_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.3 Mobile/15E148 Safari/604.1
  //Mozilla/5.0 (iPad; CPU OS 11_0 like Mac OS X) AppleWebKit/604.1.34 (KHTML, like Gecko) Version/11.0 Mobile/15A5341f Safari/604.1
  //Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3987.149 Safari/537.36
  var version = "";
  var browser = "";
  const txt = navigator.userAgent;
  const txt1 = txt.slice(txt.indexOf("(") + 1, txt.indexOf(")"));
  var pr;
  if (txt1 !== "" && txt1 !== undefined) pr = txt1.split(";");

  if (navigator.userAgent.indexOf("Chrome") > -1) {
    browser = "Chrome";
  } else if (navigator.userAgent.indexOf("Safari") > -1) {
    browser = "Safari";
  } else if (navigator.userAgent.indexOf("Opera") > -1) {
    browser = "Opera";
  } else if (navigator.userAgent.indexOf("Firefox") > -1) {
    browser = "Firefox";
  } else if (navigator.userAgent.indexOf("MSIE") > -1) {
    browser = "Internet Explorer";
  }

  if (navigator.userAgent.match(/Android/i)) {
    if (pr[1] !== undefined) {
      pr[1] = pr[1].trim();
      const pr2 = pr[1].split(" ");
      version = pr2[1];
      version = version.trim();
    }
    if (version === "" || version === undefined) version = "0";
    return { platform: "android", version: version, browser: browser };
  } else {
    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      if (pr[1] !== undefined) {
        const pr2 = pr[1].split("OS ");
        if (pr2[1] !== undefined) {
          const pr3 = pr2[1].split(" ");
          if (pr3[0] !== undefined) {
            const pr4 = pr3[0].split("_");
            if (pr4[0] !== undefined && pr4[0] !== "") {
              version = pr4[0];
              version = version.trim();
            }
          }
        }
      }
      if (version === "" || version === undefined) version = "0";
      return { platform: "ios", version: version, browser: browser };
    } else {
      if (navigator.userAgent.match(/Windows|IEMobile|Mac/i)) {
        return { platform: "desktop", version: version, browser: browser };
      } else {
        return { platform: "unknown", version: version, browser: browser };
      }
    }
  }
}

export function Width() {
  return window.innerWidth;
}

export function Height() {
  return window.innerHeight;
}

export function Standalone() {
  if (window.navigator.standalone === true) {
    return true;
  } else {
    return false;
  }
}
